import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-neutral-900 text-white hover:bg-neutral-800 focus:ring-neutral-900 shadow-sm shadow-neutral-900/10',
    secondary: 'bg-[#EDE8E3] text-neutral-900 hover:bg-[#E5DED7] focus:ring-neutral-500',
    outline: 'border-2 border-neutral-900 text-neutral-900 hover:bg-neutral-50 focus:ring-neutral-900',
    ghost: 'text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-211">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-212" />}
      {children}
    </button>;
}